import React from 'react'
import { Action } from 'redux';
import {
    GET_REQUEST,
    GET_SUCCESS,
    GET_ERROR,
    // EventsType,
    GetDispatchTypes
} from '../constants/GetByIDActionType'


interface DefaultState {
    loading: boolean,
    getItem?: {},
}


const initialState: DefaultState = {
    loading: false,
}


const GetByIdReducer = (state: DefaultState = initialState, action: GetDispatchTypes): DefaultState => {
    switch (action.type) {
        case GET_REQUEST:
            return {
                // ...state,
                loading: true
            }

        case GET_SUCCESS:
            return {
                // ...state,
                loading: false,
                getItem: action.payload,

            }

        case GET_ERROR:
            return {
                // ...state,
                loading: false,
                // error: action.payload
            }

        default:
            return state
            break;
    }
}

export default GetByIdReducer